<template>
  <div style="background-color: #f0f2f5">
    <header class="header-2">
      <div class="page-header pt-7 pb-7"
           :style="{backgroundImage: 'url('+ img + ')',minHeight:!$isMobile()?'100vh':'auto'}" loading="lazy">
        <span class="mask bg-gradient-primary opacity-8"></span>
        <div class="container">
          <div class="row">
            <div class="col-lg-10 col-12 align-items-center">
              <h1 class="text-white pt-3">Sobre nosotros</h1>
              <p class="mt-3 text-white h5">
                Ecomedica insumos médicos, es una empresa dedicada a la comercialización, administración,
                almacenamiento, logística y distribución de medicamentos e insumos para la salud en los principales
                institutos y organizaciones gubernamentales de país, con cobertura en toda la república mexicana.
              </p>
              <p class="mt-3 h5 text-white">
                Nuestra empresa cuenta con una organización responsable y comprometida para realizar los procesos
                operativos con calidad y dirección enfocados a satisfacer al cliente, nos respaldamos en todo
                momento con las buenas prácticas de almacenaje y una mejora continua en nuestros procesos.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>
    <section id="servicios" class="bg-white mt-0 pt-8 pb-8">
      <div class="container">
        <div class="w-md-70 text-center m-auto">
          <h3 class="text-primary">Nuestros servicios</h3>
          <p class="mt-3 h5 font-weight-light">
            Contamos con la infraestructura tecnológica, técnica, física y humana para brindar un servicio 100% integral
            bajo demanda a cada uno de nuestros clientes.
          </p>
          <p class="mt-3 h5 font-weight-light">
            A través de nuestra ideología, transmitimos confianza por medio de aleados que nos respaldan, así como de
            las agencias gubernamentales a las que brindamos nuestros servicios. Conoce lo que ofrecemos:
          </p>
        </div>
        <div class="mt-6 text-center">
          <b-row>
            <b-col class="mt-5 ">
              <div>
                <span class="badge bg-primary">
                  <span class="h5 text-white">
                    <i class="fa-solid fa-land-mine-on"></i>
                    OPERACIÓN
                  </span>
                </span>
                <p class="mt-2">
                  Administración de Almacenes <br>
                  y Centros de Distribución
                </p>
              </div>
            </b-col>
            <b-col class="mt-5">
              <div>
                <span class="badge bg-primary">
                  <span class="h5 text-white">
                    <i class="fa-solid fa-diagram-project"></i>
                    DISTRIBUCIÓN
                  </span>
                </span>
                <p class="mt-2">
                  Contamos con la mejor <br>
                  logística de distribución
                </p>
              </div>
            </b-col>
            <b-col class="mt-5">
              <div>
                <span class="badge bg-primary">
                  <span class="h5 text-white">
                    <i class="fa-solid fa-truck-moving"></i>
                    LOGÍSTICA
                  </span>
                </span>
                <p class="mt-2">
                  Sistema integral de <br>
                  gestión logístico
                </p>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </section>
    <section id="operacion" class="pt-7 pb-8 bg-light">
      <div class="container">
        <div>
          <h3 class="text-primary font-weight-bold">Operación</h3>
        </div>
        <div class="mt-3">
          <b-row>
            <b-col cols="12" md="3" class="mt-4">
              <div class="card bg-transparent blur shadow-blur h-100">
                <div class="card-body h-100">
                  <h5>
                    <i class="fa-solid text-primary fa-circle-check"></i>
                    Administración de Almacenes y Centros de distribución
                  </h5>
                  <p class="text-sm">
                    Implementando las buenas practicas de almacenamiento bajo la Nom-059
                  </p>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="3" class="mt-4">
              <div class="card bg-transparent blur shadow-blur h-100">
                <div class="card-body h-100">
                  <h5>
                    <i class="fa-solid text-primary fa-circle-check"></i>
                    Optimización de la cadena de suministro
                  </h5>
                  <p class="text-sm">
                    Surtido exacto en pedidos y rutas logísticas de distribución
                  </p>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="3" class="mt-4">
              <div class="card bg-transparent blur shadow-blur h-100">
                <div class="card-body h-100">
                  <h5>
                    <i class="fa-solid text-primary fa-circle-check"></i>
                    Almacén Red fría
                  </h5>
                  <p class="text-sm">
                    Instalaciones y equipo tecnológicos para control de la cadena de frío
                  </p>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="3" class="mt-4">
              <div class="card bg-transparent blur shadow-blur h-100">
                <div class="card-body h-100">
                  <h5>
                    <i class="fa-solid text-primary fa-circle-check"></i>
                    Personal calificado
                  </h5>
                  <p class="text-sm">
                    Contamos con un equipo de trabajo altamente capacitado para poder brindar un excelente servicios
                  </p>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="3" class="mt-4">
              <div class="card bg-transparent blur shadow-blur h-100">
                <div class="card-body h-100">
                  <h5>
                    <i class="fa-solid text-primary fa-circle-check"></i>
                    Administración de ordenes
                  </h5>
                  <p class="text-sm">
                    Determinar objetivos para mayor control de inventarios y disminuir pérdidas. Rutas logísticas de
                    operación para garantizar entregas puntales
                  </p>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="3" class="mt-4">
              <div class="card bg-transparent blur shadow-blur h-100">
                <div class="card-body h-100">
                  <h5>
                    <i class="fa-solid text-primary fa-circle-check"></i>
                    Estricto control de calidad
                  </h5>
                  <p class="text-sm">
                    Nuestra estrategia principal es la calidad por lo cual aseguramos la mejora continua aplicando las
                    normativas de buenas practicas de almacenamiento y distribución
                  </p>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="3" class="mt-4">
              <div class="card bg-transparent blur shadow-blur h-100">

                <div class="card-body h-100">
                  <h5>
                    <i class="fa-solid text-primary fa-circle-check"></i>
                    Asesoría logística
                  </h5>
                  <p class="text-sm">
                    Para llevar a cabo procesos de reingeniería, o implementar tecnologías de la información y hacer más
                    competitiva la cadena de suministro.
                  </p>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="3" class="mt-4">
              <div class="card bg-transparent blur shadow-blur h-100">

                <div class="card-body h-100">
                  <h5>
                    <i class="fa-solid text-primary fa-circle-check"></i>
                    Sistema de gestión de calidad
                  </h5>
                  <p class="text-sm">
                    Documentación de procesos, procedimientos y responsabilidades para ayudar a coordinar las
                    actividades y así cumplir con los objetivos y requisitos regulatorios de nuestros clientes
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </section>
    <section id="distribucion" class="pt-7 pb-5 bg-white">
      <div class="container">
        <div class="w-lg-80 w-100">
          <h3 class="text-primary">Distribución</h3>
          <p class="h5 font-weight-light mt-3">
            Nuestro servicio de distribución va desde el diseño e implementación de estrategias y plan logístico que
            ayuden a satisfacer las necesidades y expectativas de nuestros clientes, y así contribuir a mejorar la
            calidad de vida de los mexicanos.
          </p>
          <p class="h5 font-weight-light mt-3">
            Hacemos entrega a cualquier parte de la república mexicana, nos convertimos en socios estratégicos de
            nuestros clientes.
          </p>
        </div>
        <div class="mt-5">
          <b-row>
            <b-col class="mt-3" cols="12" md="6">
              <h6 class="mb-5 text-center">
                Contamos con:
              </h6>
              <b-row>
                <b-col cols="12" md="6">
                  <p>
                    <i class="fa-solid text-primary fa-arrow-right"></i>
                    Planeación de rutas
                  </p>
                </b-col>
                <b-col cols="12" md="6">
                  <p>
                    <i class="fa-solid text-primary fa-arrow-right"></i>
                    Manejo y control de entregas
                  </p>
                </b-col>
                <b-col cols="12" md="6">
                  <p>
                    <i class="fa-solid text-primary fa-arrow-right"></i>
                    Evidencias de entrega
                  </p>
                </b-col>
                <b-col cols="12" md="6">
                  <p>
                    <i class="fa-solid text-primary fa-arrow-right"></i>
                    Soporte a urgencias
                  </p>
                </b-col>
                <b-col cols="12" md="6">
                  <p>
                    <i class="fa-solid text-primary fa-arrow-right"></i>
                    Seguimiento de rutas (Trazabilidad)
                  </p>
                </b-col>
                <b-col cols="12" md="6">
                  <p>
                    <i class="fa-solid text-primary fa-arrow-right"></i>
                    Cobertura Estatal y nacional
                  </p>
                </b-col>
                <b-col cols="12" md="6">
                  <p>
                    <i class="fa-solid text-primary fa-arrow-right"></i>
                    Entrega última milla
                  </p>
                </b-col>
                <b-col cols="12" md="6">
                  <p>
                    <i class="fa-solid text-primary fa-arrow-right"></i>
                    Servicio 24/7
                  </p>
                </b-col>
              </b-row>
              <hr class="vertical dark">
            </b-col>
            <b-col class="mt-3" cols="12" md="6">
              <div>
                <h6 class="text-center mb-5">
                  Unidades de transporte:
                </h6>
                <b-row>
                  <b-col cols="12" md="6">
                    <p>
                      <i class="fa-solid text-primary fa-arrow-right"></i>
                      Transporte Red fría
                    </p>
                  </b-col>
                  <b-col cols="12" md="6">
                    <p>
                      <i class="fa-solid text-primary fa-arrow-right"></i>
                      Transporte Red seca
                    </p>
                  </b-col>
                  <b-col cols="12" md="6">
                    <p>
                      <i class="fa-solid text-primary fa-arrow-right"></i>
                      Unidades dedicadas únicamente para insumos médicos
                    </p>
                  </b-col>
                  <b-col cols="12" md="6">
                    <p>
                      <i class="fa-solid text-primary fa-arrow-right"></i>
                      Equipadas con GPS para monitoreo
                    </p>
                  </b-col>
                  <b-col cols="12" md="6">
                    <p>
                      <i class="fa-solid text-primary fa-arrow-right"></i>
                      Seguimiento de rutas (Trazabilidad)
                    </p>
                  </b-col>
                  <b-col cols="12" md="6">
                    <p>
                      <i class="fa-solid text-primary fa-arrow-right"></i>
                      Seguimiento de rutas (Trazabilidad)
                    </p>
                  </b-col>
                  <b-col cols="12" md="6">
                    <p>
                      <i class="fa-solid text-primary fa-arrow-right"></i>
                      Ajustable a las necesidades de cada proyecto.
                    </p>
                  </b-col>
                  <b-col cols="12" md="6">
                    <p>
                      <i class="fa-solid text-primary fa-arrow-right"></i>
                      Garantía de distribución acorde a requisitos sanitarios y normativas vigentes.
                    </p>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
      <div style="height: 250px"></div>
    </section>
    <section id="distribucion-redfriaseca" class="section-rf-rs pt-5  pb-9">
      <div class="container">
        <b-row style="position:relative;margin-top: -250px">
          <b-col class="mt-3" md="6" cols="12">
            <div class="card blur h-100 shadow-blur">
              <div class="card-body">
                <div>
                  <div class="d-flex align-items-center">
                    <h4 class="text-dark mt-2">
                      Distribución
                    </h4>
                    <span class="badge bg-primary mx-2 text-md">
                      Red fría
                      <i class="fa-solid fa-wind"></i>
                    </span>
                  </div>
                  <p class="h6 font-weight-light mt-3">
                    Sabemos lo importe que es para el bienestar y la salud de la población, mantener los insumos médicos
                    en
                    perfectas condiciones, es por eso que nuestros servicio de distribución en red fría cumple con los
                    estándares de calidad, normativas aplicables y requisitos sanitarios establecidos por la Comisión
                    Federal
                    para la Protección contra Riegos Sanitarios (COFEPRIS).
                  </p>
                </div>
                <div class="mt-4">
                  <b-row>
                    <b-col cols="12" md="6" class="">
                      <div class="card shadow-none bg-transparent">
                        <div class="card-body">
                          <p class="h6">
                            <i class="fa-solid text-primary fa-circle-check"></i>
                            Unidades equipadas con dispositivos de monitoreo y medición de temperatura
                          </p>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" md="6" class="">
                      <div class="card shadow-none bg-transparent">
                        <div class="card-body">
                          <p class="h6">
                            <i class="fa-solid text-primary fa-circle-check"></i>
                            Servicio basado en las normas Buenas practicas de almacenamiento y distribución
                            <b>NOM 059</b>
                          </p>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" md="6" class="">
                      <div class="card shadow-none bg-transparent">
                        <div class="card-body">
                          <p class="h6">
                            <i class="fa-solid text-primary fa-circle-check"></i>
                            Estabilidad de fármacos y medicamentos NOM 073
                            <b>NOM 073</b>
                          </p>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" md="6" class="">
                      <div class="card shadow-none bg-transparent">
                        <div class="card-body align-items-center">
                          <p class="h6">
                            <i class="fa-solid text-primary fa-circle-check"></i>
                            Estándares y regulaciones de
                            <b>COFEPRIS</b>
                          </p>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </b-col>
          <b-col class="mt-3" md="6" cols="12">
            <div class="card h-100 blur shadow-blur">
              <div class="card-body">
                <div>
                  <div class="d-flex align-items-center">
                    <h4 class="text-dark mt-2">
                      Distribución
                    </h4>
                    <span class="badge bg-primary mx-2 text-md">
                      Red seca
                      <i class="fa-solid fa-box-open"></i>
                    </span>
                  </div>
                  <p class="h6 font-weight-light mt-3">
                    Trabajamos en todo momento bajo las políticas de Buenas prácticas de almacenamiento y distribución
                    asegurando que los insumos médicos lleguen en perfectas condiciones a su destino. Gracias a nuestros
                    procedimientos de inspección que permiten detectar cualquier anormalidad y validan la eficacia del
                    sistema de calidad.
                  </p>
                </div>
                <div class="mt-4">
                  <b-row>
                    <b-col cols="12" md="6">
                      <div class="card p-0 m-0 shadow-none bg-transparent">
                        <div class="card-body">
                          <p class="h6">
                            <i class="fa-solid text-primary fa-circle-check"></i>
                            Planificación y ejecución de embarque
                          </p>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" md="6">
                      <div class="card p-0 m-0 shadow-none bg-transparent">
                        <div class="card-body">
                          <p class="h6">
                            <i class="fa-solid text-primary fa-circle-check"></i>
                            Entrega punto a punto
                          </p>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" md="6">
                      <div class="card p-0 m-0 shadow-none bg-transparent">
                        <div class="card-body">
                          <p class="h6">
                            <i class="fa-solid text-primary fa-circle-check"></i>
                            Administración de ordenes
                          </p>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" md="6">
                      <div class="card p-0 m-0 shadow-none bg-transparent">
                        <div class="card-body align-items-center">
                          <p class="h6">
                            <i class="fa-solid text-primary fa-circle-check"></i>
                            Servicio en origen y destino
                          </p>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" md="12">
                      <div class="card p-0 m-0 shadow-none bg-transparent">
                        <div class="card-body align-items-center">
                          <p class="h6">
                            <i class="fa-solid text-primary fa-circle-check"></i>
                            Servicio basado en regulaciones y normas vigentes <b>(NOM 59, NOM 072)</b>
                          </p>
                        </div>
                      </div>
                    </b-col>

                    <b-col cols="12" md="6">
                      <div class="card p-0 m-0 shadow-none bg-transparent">
                        <div class="card-body align-items-center">
                          <p class="h6">
                            <i class="fa-solid text-primary fa-circle-check"></i>
                            Evidencia de entrega
                          </p>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="12" md="6">
                      <div class="card p-0 m-0 shadow-none bg-transparent">
                        <div class="card-body align-items-center">
                          <p class="h6">
                            <i class="fa-solid text-primary fa-circle-check"></i>
                            Cobertura Estatal y Nacional
                          </p>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </section>
    <section id="logistica" class="pt-0 pb-8 bg-white">
      <div class="container">
        <div>
          <h2 class="text-primary">Logística</h2>
          <p class="h5 font-weight-lighter">
            Estamos comprometidos a brindar servicios logísticos centrados en satisfacer las necesidades del cliente a
            través de un sistema de gestión integral que nos permite organizar y gestionar de manera sincronizada los
            diferentes departamentos, procesos, recursos y flujos relacionados con la entrega al cliente final.
          </p>
          <div class="mt-5">
            <p class="h5">
              Principales beneficios:
            </p>
            <b-row class="mt-3">
              <b-col cols="12" md="4">
                <p class="h6">
                  <i class="fa-solid text-primary fa-circle-check"></i>
                  Control inventarios
                </p>
              </b-col>
              <b-col cols="12" md="4">
                <p class="h6">
                  <i class="fa-solid text-primary fa-circle-check"></i>
                  Procesos operativos de almacenes y centros de distribución
                </p>
              </b-col>
              <b-col cols="12" md="4">
                <p class="h6">
                  <i class="fa-solid text-primary fa-circle-check"></i>
                  Transporte de insumos (última milla)
                </p>
              </b-col>
              <b-col cols="12" md="4">
                <p class="h6">
                  <i class="fa-solid text-primary fa-circle-check"></i>
                  Trazabilidad
                </p>
              </b-col>
              <b-col cols="12" md="4">
                <p class="h6">
                  <i class="fa-solid text-primary fa-circle-check"></i>
                  Logística inversa
                </p>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </section>
    <section id="contacto" class="pt-5 pb-0 bg-white">
      <hr class="horizontal dark m-0">
      <div class="container mt-7">
        <div class="mt-5">
          <div>
            <h2 class="text-primary">Contacto</h2>
            <p>
              Puedes llenar el siguiente formulario
              para ponerte en contacto con nosotros
            </p>
            <div class="mt-4">
              <b-row>
                <b-col cols="12" md="4" class="mt-4">
                  <div :class="['input-group input-group-outline',{
                    'is-invalid':form.nombre.isValid === false
                  }]">
                    <label class="form-label" for="nombre">
                      Tu nombre
                    </label>
                    <input type="text" class="form-control"
                           v-model="form.nombre.value"
                           :disabled="sendigForm"
                           id="nombre">
                  </div>
                </b-col>
                <b-col cols="12" md="4" class="mt-4">
                  <div :class="['input-group input-group-outline',{
                    'is-invalid':form.email.isValid === false
                  }]">
                    <label class="form-label" for="email">
                      Tu email
                    </label>
                    <input type="email" class="form-control"
                           v-model="form.email.value"
                           :disabled="sendigForm"
                           id="email">
                  </div>
                </b-col>
                <b-col cols="12" md="4" class="mt-4">
                  <div :class="['input-group input-group-outline',{
                    'is-invalid':form.asunto.isValid === false
                  }]">
                    <label class="form-label" for="asunto">
                      Asunto
                    </label>
                    <input type="text" class="form-control "
                           v-model="form.asunto.value"
                           :disabled="sendigForm"
                           id="asunto">
                  </div>
                </b-col>
                <b-col cols="12" md="12" class="mt-4">
                  <div :class="['input-group input-group-outline',{
                    'is-invalid':form.mensaje.isValid === false
                  }]">
                    <label class="form-label" for="mensaje">
                      Mensaje
                    </label>
                    <input class="form-control" :disabled="sendigForm"
                           style="height: 100px"
                           v-model="form.mensaje.value"
                           id="mensaje"/>
                  </div>
                </b-col>
                <b-col cols="12" md="12" class="mt-4">
                  <b-row>
                    <b-col cols="12" md="6">
                      <div v-if="errorForm">
                        <p class="m-0 text-danger">
                          <i class="fa-solid fa-circle-exclamation"></i>
                          {{ errorForm }}
                        </p>
                      </div>
                      <div v-if="sendedForm">
                        <h6 class="m-0 text-primary">
                          <i class="fa-solid fa-circle-check"></i>
                          Se ha enviado tu información. Pronto nos contactaremos
                          contigo.
                        </h6>
                      </div>
                    </b-col>
                    <b-col cols="12" md="6">
                      <button class="btn btn-primary shadow-none float-end font-weight-bold"
                              @click="enviarForm"
                              :disabled="sendigForm" type="button">
                        <span v-if="!sendigForm">
                          <i class="fa-solid fa-arrow-right-long"></i>
                          Enviar información
                        </span>
                        <span v-else class="text-white">
                          Enviando, espera un momento . . .
                        </span>
                      </button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>
          <hr clasS="horizontal dark">
          <div class="mt-6">
            <p class="text-sm font-weight-lighter mb-4">
              <i class="fa-solid text-primary fa-circle-question"></i>
              También a través de los siguientes medios:
            </p>
            <b-row>
              <b-col cols="12" class="mt-3" md="4">
                <p class="h6">
                  <i class="fa-solid fa-location-dot"></i>
                  Domicilio:
                </p>
                <a href="https://goo.gl/maps/5C7TzSGxRSD8NKEt8"
                   class="text-secondary"
                   target="_blank">
                  <p>
                    Gante #669 Col. Las Conchas
                    Guadalajara, Jal. C.P. 44460
                  </p>
                </a>
              </b-col>
              <b-col cols="12" class="mt-3" md="4">
                <p class="h6">
                  <i class="fa-solid fa-phone"></i>
                  Teléfono:
                </p>
                <a href="tel:+523330455896"
                   class="text-secondary"
                   target="_blank">
                  (33) 3045 5896
                </a>
              </b-col>
              <b-col cols="12" class="mt-3" md="4">
                <p class="h6">
                  <i class="fa-solid fa-envelope"></i>
                  Email:
                </p>
                <a href="mailto:contacto@ecomedica.com.mx"
                   class="text-secondary"
                   target="_blank">
                  contacto@ecomedica.com.mx
                </a>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
      <div class="mt-7">
        <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d466.6505307311586!2d-103.33567798531952!3d20.661267900000002!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428b221fea3c36d%3A0x67d000452b061e6c!2sC.%20Gante%20669%2C%20Las%20Conchas%2C%2044460%20Guadalajara%2C%20Jal.!5e0!3m2!1ses-419!2smx!4v1652218670181!5m2!1ses-419!2smx"
            width="100%"
            height="450" style="border:0;"
            allowfullscreen="" loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"/>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      img: require("@/assets/images/bck.jpg"),
      sendigForm: false,
      errorForm: null,
      sendedForm: false,
      form: {
        nombre: {
          value: "",
          isValid: null,
        },
        email: {
          value: "",
          isValid: null,
          regex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        },
        asunto: {
          value: "",
          isValid: null,
        },
        mensaje: {
          value: "",
          isValid: null
        }
      }
    }
  },
  methods: {
    validarForm() {
      let invalid = false;
      Object.keys(this.form).forEach(n => {
        let item = this.form[n];
        this.form[n].isValid = null;
        if ("regex" in item) {
          if (!item.regex.test(item.value)) {
            invalid = true;
            this.form[n].isValid = false;
          }
        } else {
          if (item.value.trim() === "") {
            invalid = true;
            this.form[n].isValid = false;
          }
        }
      });
      return !invalid;
    },
    enviarForm() {
      this.sendedForm = false;
      if (!this.sendigForm) {
        this.errorForm = null;
        if (this.validarForm()) {
          this.sendigForm = true;
          let model = {
            nombre: this.form.nombre.value.trim(),
            email: this.form.email.value.trim(),
            asunto: this.form.asunto.value.trim(),
            mensaje: this.form.mensaje.value.trim(),
          };
          let url = "http://ecomedica.com.mx/form/send-form.php"
          window.$.post(url, model).then(r => {
            r = JSON.parse(r);
            if (r.request) {
              this.form.nombre.value = ""
              this.form.email.value = ""
              this.form.asunto.value = ""
              this.form.mensaje.value = ""
              this.sendedForm = true;
            } else {
              this.errorForm = "Ocurrió un error desconocido, " +
                  "por favor inténtalo más tarde";
            }
            this.sendigForm = false;
          }, () => {
            this.errorForm = "Ocurrió un error desconocido, " +
                "por favor inténtalo más tarde";
            this.sendigForm = false;
          })
        } else {
          this.errorForm = "Por favor llena todos " +
              "los campos correctamente"
        }
      }
    }
  }

}
</script>

<style scoped>
.primary-hover {
  transition: 300ms ease;
  cursor: pointer;
}

.primary-hover:hover {
  background-color: var(--main-color) !important;
  transition: 300ms ease;
  color: white !important;
}

.primary-hover:hover i {
  color: white !important;
}

.section-rf-rs {
  background: rgb(186, 201, 74);
  background: linear-gradient(180deg, rgba(186, 201, 74, 1) 0%, rgba(255, 255, 255, 1) 100%);
}
</style>